function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomoePlainMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274.723,
    height: 276.14,
    viewBox: "0 0 72.687 73.062",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      strokeWidth: 1
    },
    d: "M47.464 83.617c-15.394-1.65-24.976-11.309-25.867-26.071-1.091-18.075 25.44-21.508 28.812-3.73l.272 1.437-.095 1.94c-.193 3.906-1.686 7.157-4.53 9.863L44.958 68.1l.415.317c3.717 2.837 9.946 4.53 15.938 4.333l2.998-.099 1.711-.367c9.113-1.953 16.55-8.367 20.363-17.56.688-1.658.719-1.553.222.752-3.738 17.348-21.396 30.043-39.141 28.14zm-21.032-9.359C4.8 54.794 15.23 14.468 42.172 13.414l2.382-.093 2.116.283c6.154.821 11.386 3.071 14.316 6.155 7.463 7.856 3.426 21.115-7.234 23.76l-1.56.388-1.9-.003-1.897-.004-1.568-.37c-2.79-.66-5.167-2.08-7.292-4.356l-1.248-1.337-.794-1.61c-.437-.887-.96-2.287-1.165-3.111-.204-.825-.395-1.527-.425-1.56-.03-.033-.596.239-1.258.604-7.013 3.865-12.06 10.81-13.677 18.82l-.4 1.98-.002 3.263-.002 3.263.42 2.028c.914 4.421 3.122 9.174 5.864 12.626.573.72 1.01 1.31.974 1.31-.037 0-.662-.537-1.39-1.192zm36.92-4.458c-5.936-1.244-10.558-5.968-11.583-11.837l-.289-1.652.103-1.588c.625-9.66 9.834-15.918 19.3-13.114 1.62.48 1.53.673 1.297-2.798C71.024 21.645 57.127 10.706 39.262 12.9l-.882.108 1.5-.532c3.527-1.253 7.86-1.853 12.347-1.712l3.086.097 2.44.46c17.023 3.206 30.5 19.409 29.7 35.71l-.1 2.048-.538 2.117-.538 2.116-1.237 2.47c-3.27 6.524-9.233 12.162-14.469 13.678l-1.323.383-2.558.06c-1.406.033-2.908-.013-3.338-.103z",
    transform: "translate(-14.8 -10.743)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomoePlainMin);
export default __webpack_public_path__ + "static/media/tomoe_plain-min.704f40e5ec4bd969cd51beb0fcc70f3c.svg";
export { ForwardRef as ReactComponent };